// File will be used only for production build process this just export empty {}

// respectiv env config configuration can be set in helm/values.dev.yaml, helm/values.prod.yaml etc
/*
    sample config
    For dev env - helm/values.dev.yaml
    env:
        SAMPLE_KEY: "dev-sample-key"
        BFF_URL: "https://fps-bff-v2-dev-us-east4.propay-eepay-fps.ngp.ukg.dev"

    For prod env - helm/values.prod.yaml
    env:
        SAMPLE_KEY: "prod-sample-key"
        BFF_URL: "https://fps-bff-v2-prod-us-east4.propay-eepay-fps.ngp.ukg.dev"
*/

// window.envData.envConfig in set in index.html file in the deployment process based on the environment
// window.envData.envConfig used as env-config in src/app/env-config/index.ts

/**
 * sample envConfig settting index.html
 * window.envData.envConfig = {
 *    SAMPLE_KEY: '${SAMPLE_KEY}',
 *    bffUrl: '${BFF_URL}',
 *    trexApiUrl: '${TREX_API_URL}'
 * };
 */

const config = {};
// Export the default empty config for frontend build process, during the deployment process right config.json will be injected in index.html replacing _ENV_CONFIG_
export default config;
